import {DocumentFormBuilderComponent} from "../document-form-builder.component";
import {OnInit} from "@angular/core";
import {Claim} from "../../../model/claim.model";
import {DocumentField} from "../../../model/document-field";
import {SmartqDocuments} from "../../../model/smartq-documents.model";
import {ClaimTypes} from "../../../model/claim-type.model";
import { HomeFormBuilderUtil } from "./home-form-builder-util";

export class WaterFormBuilder extends DocumentFormBuilderComponent implements OnInit {
   
    constructor(claim: Claim){
        super(claim);
       this.documentFormClaimType = ClaimTypes[ClaimTypes.CLAIM_TYPE_HOME_WATER];
    }

    setRequiredDocuments(){
        let requiredDocuments: DocumentField[] = [];

        requiredDocuments.push(new DocumentField('WATERREPREPINVOICES', 'homeProduct.supportingDocs.types.repairReplacementInvoices', SmartqDocuments.HOME_INVOICE, true));
        requiredDocuments.push(new DocumentField('WATERREPRECEIPT', 'homeProduct.supportingDocs.types.possibleRepairReceipt', SmartqDocuments.HOME_REPRECEIPT, true));
        requiredDocuments.push(new DocumentField('WATERPURCHRECEIPT', 'homeProduct.supportingDocs.types.purchaseReceiptLoss', SmartqDocuments.HOME_REPINVOICE, true));
        requiredDocuments.push(new DocumentField('WATERPHOTOS', 'homeProduct.supportingDocs.types.photoDamagePropertyScene', SmartqDocuments.HOME_PHOTOS, true));
        requiredDocuments.push(new DocumentField('WATERREPORT', 'homeProduct.supportingDocs.types.buildingReport', SmartqDocuments.HOME_REPORT, true));
        
        let utilities: HomeFormBuilderUtil = new HomeFormBuilderUtil();
        requiredDocuments = requiredDocuments.concat(utilities.getRiskDocuments(this.claim));
        
        this.requiredDocuments = requiredDocuments;
    }
}